import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice";
import store from "app/redux/store/store";

const Backbone = require('backbone')
declare var EditarParcelaController:any

var usuarioLogado = global.sessionStorage.getData('UsuarioLogado');
const ParcelaItemView = Backbone.Marionette.ItemView.extend({
    template: "#template-parcelas-item",
    tagName: "tr",
    className: "clicavel",

    initialize: function(options) {
        this.app = options.app;
        this.parent = options.parent;
        this.orcamento = options.orcamento;
        this.controller = options.controller;

        if (!usuarioLogado || !(usuarioLogado && usuarioLogado.CorFundo || usuarioLogado.CorTexto)) {
            usuarioLogado = { CorFundo: "#FFFFCC", CorTexto: "#000000" };
        } 
    },

    events: {
        'click td.selecionavel': "selecionarParcela",
        'click a[editar]': "editarParcela",
    },

    editarParcela: function() {

        var m = this.model.toJSON();

        this.editarParcelaController = this.controller.showView({
            region: {
                name: "editarParcelaRegion",
                selector: "#editar-parcela-region"
            },
            model: m,
            controller: {
                type: EditarParcelaController,
                args: {
                    orcamento: this.orcamento,
                    parcela: this.model,
                    finalizarEdicaoCallback: $.proxy(this.finalizarEdicao, this),
                    cancelarEdicaoCallback: $.proxy(this.cancelarEdicao, this),
                    readOnly: this.controller.readOnly
                }
            }
        });
    },

    finalizarEdicao: function(data) {

        if (!data || !data.ParcelasFormaPagamento) {
            return;
        }

        this.controller.atualizarParcelas(data.ParcelasFormaPagamento);

        this.editarParcelaController.hide();
        this.controller.show();

    },

    cancelarEdicao: function() {

    },

    selecionarParcela: function(e) {

        var cor = $(e.target).parents("tr").css("background-color");

        if (cor === "rgb(255, 255, 255)" || cor === "transparent" || cor === "rgba(0, 0, 0, 0)") {
            $(e.target).parents("tr").css({ "background-color": usuarioLogado.CorFundo, "color": usuarioLogado.CorTexto });
            this.model.set("selecionado", true);
        } else {
            $(e.target).parents("tr").css({ "background-color": '', "color": '' });
            this.model.set("selecionado", false);
        }

        this.controller.habilitarBotoesEdicaoParcela();

    },
});

(window as any).ParcelaItemView = ParcelaItemView


const ParcelaView = Backbone.Marionette.CompositeView.extend({
    template: "#template-parcelas",
    childView: ParcelaItemView,
    childViewContainer: "#lista-parcelas",

    initialize: function(options) {
        this.app = options.app;
        this.verificarCartaoParcelado();
    },

    buildChildView: function(item, itemView) {

        var view = new itemView({
            model: item,
            app: this.app,
            parent: this,
            orcamento: this.model,
            controller: this.controller
        });
        return view;
    },
    
    verificarCartaoParcelado: function () {

        this.model.set('possuiCartaoParcelado', false);
        store.dispatch(sobrescreverInformacoesAction({possuiCartaoParcelado: false}))

        var self = this;

        this.collection.each(function (item) {
            if (item.get('QuantidadeParcelasCartao') > 1) {
                self.model.set('possuiCartaoParcelado', true);
                store.dispatch(sobrescreverInformacoesAction({possuiCartaoParcelado: true}))
                return false;
            }
        });
    }

});

(window as any).ParcelaView = ParcelaView